import { takeLatest, takeEvery } from 'redux-saga/effects';
import { savePoiFromWS, saveSelectedPoi, getPoiInformation, filterPoiList } from './PoiSagas';
import {
  initWs,
  poiList,
  poiDetail,
  poiDetailUpdate,
  sendGenericMessage,
  routeList,
  dropRouteList,
  routeWaypointDetails,
  favoriteList,
  recentList,
  quickLinks,
  turnByTurnRoutes,
  dialogContinue,
  dialogCancel,
} from './ConnectionSagas';
import { POI_ACTION_TYPES, WS_ACTION_TYPES } from '../actionTypes';

export function* getPoiWatcher() {
  yield takeLatest(POI_ACTION_TYPES.GET_POI_INFORMATION.LOADING, getPoiInformation);
}

export function* getPoiFromWSWatcher() {
  yield takeLatest(POI_ACTION_TYPES.POI_LIST, savePoiFromWS);
  yield takeLatest(POI_ACTION_TYPES.POI_SELECTED.LOADING, saveSelectedPoi);
  yield takeLatest(POI_ACTION_TYPES.FILTER.APPLY, filterPoiList);
}

export function* connectionWatcher() {
  yield takeLatest(WS_ACTION_TYPES.WS.INIT, initWs);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_LIST, poiList);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_DETAIL, poiDetail);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_DETAIL_UPDATE, poiDetailUpdate);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_COMMANDS, sendGenericMessage);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_ROUTE_LIST, routeList);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_DROP_ROUTE_LIST, dropRouteList);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_ROUTE_WAYPOINT_DETAILS, routeWaypointDetails);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_FAVORITE_LIST, favoriteList);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_RECENT_LIST, recentList);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_QUICKLINKS, quickLinks);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_TURN_BY_TURN, turnByTurnRoutes);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_DIALOG_CONTINUE, dialogContinue);
  yield takeEvery(WS_ACTION_TYPES.WS.ON_MESSAGES_DIALOG_CANCEL, dialogCancel);
}
